import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac62fa4a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Cannibalization BidOptimizer "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " Cease paying for keywords where you're organically thriving. Why bid on ASINs already enjoying a high organic rank? With our Cannibalization BidOptimizer, you have the power to decide. ")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subheader"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "subheader-group"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Maximize Profit "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " You safeguard your margins and profit by avoiding overspending on high-performing organic keywords. ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "subheader-line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "subheader-group"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Elevate Lesser-Known Products "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " With no additional cost, divert more of your advertising budget towards boosting visibility for your underperforming products. ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "subheader-line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "subheader-group"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Adjust Organic Rank Threshold "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, " By default, the system will start modulating bids for products that rank organically below the 8th position. To adjust this, simply select your preferred rank below. ")])], -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "chart-box",
  ref: "chartBox"
};
const _hoisted_5 = {
  class: "chart-box-inner"
};
const _hoisted_6 = {
  class: "slider-container"
};
const _hoisted_7 = {
  class: "footer"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " Caution "), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createTextVNode(" Setting the starting rank to "), /*#__PURE__*/_createElementVNode("b", null, "'1'"), /*#__PURE__*/_createTextVNode(" will have the highest margin decrease, while setting it to "), /*#__PURE__*/_createElementVNode("b", null, "'10'"), /*#__PURE__*/_createTextVNode(" means minimal margin optimization. Avoid setting it to "), /*#__PURE__*/_createElementVNode("b", null, "'0'"), /*#__PURE__*/_createTextVNode(" as this deactivates margin adjustment, which might lead to overbidding. ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_bid_chart = _resolveComponent("ppc-bid-chart");
  const _component_app_slider = _resolveComponent("app-slider");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  return _openBlock(), _createBlock(_component_app_card_custom, {
    "no-padding": ""
  }, {
    default: _withCtx(() => [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.chartWidth > 0 ? (_openBlock(), _createBlock(_component_ppc_bid_chart, {
      key: 0,
      width: $data.chartWidth,
      height: $data.chartHeight,
      max: $data.levels.length,
      current: $props.bid
    }, null, 8, ["width", "height", "max", "current"])) : _createCommentVNode("", true)])], 512), _createElementVNode("div", _hoisted_6, [_createVNode(_component_app_slider, {
      modelValue: $options.localBid,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localBid = $event),
      options: $data.levels,
      "padding-top": 0,
      "padding-bottom": 12,
      offsetLeft: 44,
      variant: "purple"
    }, null, 8, ["modelValue", "options"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_app_icon, {
      icon: "warning2"
    }), _hoisted_8])]),
    _: 1
  });
}